import { render } from "./CoursePreparationList.vue?vue&type=template&id=adbb33f4"
import script from "./CoursePreparationList.vue?vue&type=script&lang=js"
export * from "./CoursePreparationList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__